// extracted by mini-css-extract-plugin
export var shake = "_g-1";
export var toastCloseButton = "_g-0";